import { useContext } from 'react'
import {
  GlobalDataContext,
  TemplateContext,
  evaluateTemplateValue,
} from '@ea-lab/reactive-json'

/**
 * ReactiveJSON primitive — outputs a string mapped from a value via a
 * lookup table. Useful for embedding human-readable labels derived from
 * machine values (e.g. `titleAlign: "left"` → `"Left"`).
 *
 * YAML usage (inside a content array):
 *   - "Title align: "
 *   - type: MapText
 *     value: ~~.titleAlign
 *     map: {left: "Left", center: "Center", right: "Right"}
 *     # `map` may also be a store reference (`~~.typeLabels`) so one table can
 *     # be shared with, say, a FacetList `labelMap` instead of being copied.
 *     default: ""           # optional fallback
 */
export const MapText = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)
  const value = evaluateTemplateValue({
    valueToEvaluate: props.value,
    globalDataContext,
    templateContext,
  })
  const map = evaluateTemplateValue({
    valueToEvaluate: props.map,
    globalDataContext,
    templateContext,
  }) ?? {}
  // Résolu aussi : le repli utile est souvent la valeur brute (`default: ~.type`).
  const fallback = evaluateTemplateValue({
    valueToEvaluate: props.default,
    globalDataContext,
    templateContext,
  }) ?? ''
  const mapped = Object.prototype.hasOwnProperty.call(map, value) ? map[value] : fallback
  return <>{mapped}</>
}
